var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempSensitive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 30,
    viewBox: "0 0 23 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11.201 36.189A7.207 7.207 0 0 1 7.528 22.78V1.151c0-.203.164-.367.367-.367h6.612c.203 0 .367.164.367.367v21.63a7.215 7.215 0 0 1-3.673 13.408zM8.248 1.519v21.475a.353.353 0 0 1-.191.315 6.48 6.48 0 1 0 6.296 0 .353.353 0 0 1-.191-.315V1.518H8.248z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M11.201 33.58a4.665 4.665 0 0 1-2.057-8.816V4.296c0-.203.164-.368.367-.368h3.387c.203 0 .368.165.368.368v20.431a4.665 4.665 0 0 1-2.065 8.817v.036zM9.879 4.663v20.3c-.001.148-.091.281-.228.337a3.93 3.93 0 1 0 3.1 0 .375.375 0 0 1-.22-.337v-20.3H9.879z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.509 15.198h-3.1a.367.367 0 1 1 0-.734h3.004l15.671-9.272a.316.316 0 0 1 .184-.052h2.733c.203 0 .367.165.367.368a.375.375 0 0 1-.367.367h-2.63L3.714 15.147a.353.353 0 0 1-.205.051z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempSensitive);
export default __webpack_public_path__ + "static/media/temp-sensitive.a1d1fbd2a95c8d49db01fb706fbc8145.svg";
export { ForwardRef as ReactComponent };